import ENDPOINTS from 'api/endpoints';
import type { IntegrationFormConfig } from '../types';
import { transformPhoneNumberPatternErrors } from '../utils/errorTransformers';
import { createPhoneNumbersDataSource } from '../utils/phoneNumbersDataSource';

const PHONE_NUMBER_WITH_COUNTRY_CODE_PATTERN = '^\\+[1-9]\\d{6,14}$';

export const dialpadFormConfig: IntegrationFormConfig = {
  dataSource: {
    path: `${ENDPOINTS.TELEPHONY_GATEWAY_PROXY}/dialpad`,
    configPath: 'config',
  },
  steps: [
    {
      title: 'Step 1: Configure Dialpad',
      description:
        'Configure the routing from Dialpad to PolyAI. Routes are provided by the Dialpad SIP trunk provisioning team. Use the Call Handoff page to configure SIP transfers back to Dialpad',
      dataSource: createPhoneNumbersDataSource('dialpad'),
      schema: {
        required: ['sandbox', 'prerelease', 'live'],
        type: 'object',
        properties: {
          sandbox: {
            type: 'array',
            title: 'Sandbox',
            items: {
              type: 'string',
              pattern: PHONE_NUMBER_WITH_COUNTRY_CODE_PATTERN,
              minLength: 4,
            },
            default: [],
          },
          prerelease: {
            type: 'array',
            title: 'Pre-release',
            items: {
              type: 'string',
              pattern: PHONE_NUMBER_WITH_COUNTRY_CODE_PATTERN,
              minLength: 4,
            },
            default: [],
          },
          live: {
            type: 'array',
            title: 'Live',
            items: {
              type: 'string',
              pattern: PHONE_NUMBER_WITH_COUNTRY_CODE_PATTERN,
              minLength: 4,
            },
            default: [],
          },
        },
      },
      uiSchema: {
        sandbox: {
          'ui:widget': 'TagInputWidget',
          'ui:patternErrorMessage':
            'Please enter a valid phone number with country code (e.g. +441234567890)',
        },
        prerelease: {
          'ui:widget': 'TagInputWidget',
          'ui:patternErrorMessage':
            'Please enter a valid phone number with country code (e.g. +441234567890)',
        },
        live: {
          'ui:widget': 'TagInputWidget',
          'ui:patternErrorMessage':
            'Please enter a valid phone number with country code (e.g. +441234567890)',
        },
      },
      transformErrors: errors => {
        const newErrors = transformPhoneNumberPatternErrors(errors);
        return newErrors;
      },
    },
  ],
  onSubmit: {
    path: `${ENDPOINTS.TELEPHONY_GATEWAY_PROXY}/dialpad`,
    data: ['sandbox', 'prerelease', 'live'],
  },
};
